var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg020Heart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_020-heart",
    "data-name": "020-heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.985,
    height: 53.619,
    viewBox: "0 0 65.985 53.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7208",
    "data-name": "Group 7208",
    transform: "translate(41.133 28.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7207",
    "data-name": "Group 7207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7206",
    "data-name": "Group 7206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7205",
    "data-name": "Group 7205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7204",
    "data-name": "Group 7204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7203",
    "data-name": "Group 7203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17198",
    "data-name": "Path 17198",
    d: "M334.694,276.085h-4.885V271.2h-5.755v4.885h-4.885v5.755h4.885v4.885h5.755V281.84h4.885Z",
    transform: "translate(-319.168 -271.2)",
    fill: "#00acb1"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7209",
    "data-name": "Group 7209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17199",
    "data-name": "Path 17199",
    d: "M51.383,67.592a22.649,22.649,0,0,0,.371-4.219A15.215,15.215,0,0,0,47.2,51.957a15.223,15.223,0,0,0-10.535-3.989c-5.934,0-9.154,2.8-10.8,5.108-1.643-2.313-4.857-5.108-10.784-5.108a15.205,15.205,0,0,0-10.53,3.989A15.222,15.222,0,0,0,0,63.373,20.522,20.522,0,0,0,3.028,74.412C6.59,80.418,16.4,85.477,21.667,88.194c1.356.7,2.426,1.251,2.98,1.6a2.271,2.271,0,0,0,2.424,0c.551-.349,1.614-.894,2.96-1.584.616-.316,1.282-.657,1.989-1.026a17.089,17.089,0,1,0,19.364-19.6ZM28.855,85.924c-1.288.66-2.328,1.194-2.993,1.595-.668-.405-1.715-.946-3.014-1.615C17.809,83.3,8.43,78.467,5.244,73.1a17.846,17.846,0,0,1-2.667-9.724c0-8.861,6.278-12.827,12.5-12.827,5.754,0,8.3,3.154,9.311,5.035a1.667,1.667,0,0,0,1.471.879h0a1.667,1.667,0,0,0,1.472-.878c1.011-1.881,3.568-5.037,9.332-5.037,6.228,0,12.511,3.966,12.511,12.827a19.806,19.806,0,0,1-.385,4.039A17.108,17.108,0,0,0,31.808,84.391C30.739,84.957,29.745,85.467,28.855,85.924ZM48.9,99.01A14.511,14.511,0,1,1,63.407,84.5,14.527,14.527,0,0,1,48.9,99.01Z",
    transform: "translate(0 -47.968)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg020Heart);
export default __webpack_public_path__ + "static/media/020-heart.316dc3e7ef8076abf0d9c9d8b3688f5b.svg";
export { ForwardRef as ReactComponent };